import * as React from 'react'
import classNames from 'classnames'

import type { Props as MessageCardProps } from './MessageCard'
import Slider from '../Slider'
import MessageCard from './MessageCard'
import style from './style.scss'

type Props = {
  className?: string
  messages: MessageCardProps[]
}

function MessageCards(props: Props) {
  const { className = '', messages } = props

  return (
    <Slider className={classNames(style.slider, className)}>
      {() => (
        <ul className={style.inner}>
          {messages.map((message, index) => (
            <MessageCard
              key={message.headlineText}
              className={style[className]}
              number={message.showNumber ? index + 1 : undefined}
              {...message}
            />
          ))}
        </ul>
      )}
    </Slider>
  )
}

export default MessageCards
